export * from './authentication.service';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/auth/index.ts